import { useNavigationStore } from "~/stores/navigation";

export default defineNuxtPlugin({
  name: "kleanz:navBarConfig",
  dependsOn: ["ckweb:auth"],
  setup(nuxtApp) {
    nuxtApp.hook("page:finish", () => {
      const navigationStore = useNavigationStore();
      const route = useRoute();
      const nextMenu = route.meta.menu ? route.meta.menu : "main";
      navigationStore.updateCurrentMenu(nextMenu);
    });
  },
});
